import type {ReactNode} from 'react';
import {QueryClientProvider} from '@tanstack/react-query';
import {Theme} from '@astryxdesign/core/theme';
import {InternationalizationProvider} from '@astryxdesign/core/i18n';
import ruRU from '@astryxdesign/core/locales/ru-RU.generated.js';
import {appTheme} from '@/themes/app/app';
import {queryClient} from './queryClient';

export function AppProviders({children}: {children: ReactNode}) {
  return (
    <QueryClientProvider client={queryClient}>
      <InternationalizationProvider locale="ru-RU" messages={{'ru-RU': ruRU}}>
        <Theme theme={appTheme} mode="dark">
          {children}
        </Theme>
      </InternationalizationProvider>
    </QueryClientProvider>
  );
}
